import styled from 'styled-components';

import { NumberInput } from '@dreryk/react-components';

export const StyledSlotBookingLeadPeriodInHoursField = styled(NumberInput)`
   width: 72px;
`;
